import React, { useEffect, useState } from "react";
import "./CompanyHeader.css"; // Import CSS for styling
import { getCompanyByName } from "../api/add-company";

type Company = {
  logoUrl: string;
  companyName: string;
  phoneNumber: string;
  address: string;
  email: string;
  isActive: boolean;
  duration: string;
  link: string;
};

const CompanyHeader: React.FC = () => {
  const [company, setCompany] = useState<Company[] | null>(null);

  useEffect(() => {
    const location = window.location.pathname;

    // Fetch company data from the database
    const fetchCompanyData = async () => {
      try {
        const response = await getCompanyByName(location.split("/")[2]); // Replace with your API endpoint
        setCompany(response);
      } catch (error) {
        // console.error("Error fetching company data:", error);
      }
    };

    fetchCompanyData();
  }, []);

  if (!company) {
    return <div>Loading...</div>; // Show a loading state while fetching data
  }

  return (
    <header className="company-header">
      <div className="company-header-content">
        {/* Company Logo */}
        {/* <div className="company-logo">
          <img src={company.logoUrl} alt={`${company.companyName} Logo`} />
        </div> */}

        {/* Company Name */}
        <div className="company-name">
          <a href={company[0]?.link}>
            <h1>{company[0]?.companyName}</h1>
          </a>
        </div>
        <div className="company-name">
          <p>{company[0]?.phoneNumber}</p>
        </div>
        <div className="company-name">
          <p>{company[0]?.address}</p>
        </div>

        {/* Navigation Menu */}
        {/* <nav className="company-navigation">
          <ul>
            {company?.map((link, index) => (
              <li key={index}>
                <a>{link.companyName}</a>
              </li>
            ))}
          </ul>
        </nav> */}
      </div>
    </header>
  );
};

export default CompanyHeader;
